import type { CSSObject, Theme } from "@mui/material/styles";
import { HIGHLIGHT_COLORS } from "../../constants/appColors";

/**
 * Shared "active filter" highlight styles for outlined form fields.
 *
 * Works for both selector shapes:
 *  - `&.MuiOutlinedInput-root`  → the styled element IS the input root
 *    (e.g. a styled MUI `Select`).
 *  - `& .MuiOutlinedInput-root` → the input root is a descendant
 *    (e.g. TextField, DatePicker, Autocomplete).
 *
 * Pass the MUI `theme` so dark/light variants resolve, then spread inside a
 * styled(...) callback or use as an `sx` entry:
 *
 *   ...(highlight ? FIELD_HIGHLIGHT_SX(theme) : {}),
 */
export const FIELD_HIGHLIGHT_SX = (theme: Theme): CSSObject => ({
  "&.MuiOutlinedInput-root, & .MuiOutlinedInput-root": {
    backgroundColor: HIGHLIGHT_COLORS.background[theme.palette.mode],

    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: HIGHLIGHT_COLORS.border[theme.palette.mode],
      borderWidth: "2px",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: HIGHLIGHT_COLORS.borderActive[theme.palette.mode],
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: HIGHLIGHT_COLORS.borderActive[theme.palette.mode],
      borderWidth: "2px",
    },

    // Keep the select's inner surface transparent so the root fill shows.
    "& .MuiSelect-select": {
      backgroundColor: "transparent",
    },
  },
});
